export default __webpack_public_path__ + "static/media/penguin-4.b320090c.png";